import { createFileRoute } from "@tanstack/react-router";
import { ContractPurchasesPage } from "@/features/contracts/contract-purchases-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia-zakup/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.szablony",
			location.pathname,
		);
	},
	component: ContractPurchasesPage,
});
